export default {
    data(){
        return{
            
        }
    },
    methods: {
        convertTime12to24(time12h) {
            var time = time12h;
            var hours = Number(time.match(/^(\d+)/)[1]);
            var minutes = Number(time.match(/:(\d+)/)[1]);
            var AMPM = time.match(/\s(.*)$/)[1];
            if((AMPM == "PM" || AMPM == "pm") && hours<12) hours = hours+12;
            if((AMPM == "AM" || AMPM == "am") && hours==12) hours = hours-12;
            var sHours = hours.toString();
            var sMinutes = minutes.toString();
            if(hours<10) sHours = "0" + sHours;
            if(minutes<10) sMinutes = "0" + sMinutes;
            return sHours + ":" + sMinutes + ":00";
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/time_utils.js